import React from "react";
import CodeExample from "../../partials/content/CodeExample";
import { Table } from "react-bootstrap";
import { getHelp,getFile } from "../../crud/auth.crud";
import ReactPlayer from 'react-player'

export default class Help extends React.Component {
  state = {
    help:[]
  }

  accordion=(id,videoUrl)=>{


      if(this.state[id+'ck']!=null && this.state[id+'ck']=='show')
      {
        this.setState({[id+'ck']:'',[id+'cc']:''});
      }
      else
      {
        getFile(id,videoUrl).then(response => response.data)
        .then((data) => {
          this.setState({[id+'url']: data.downloadUrl})
        });
        this.setState({[id+'ck']:'show',[id+'cc']:'collapsed'});
      }

      //console.log(id);
      //console.log(this.state[id+'ck']);
      //console.log(this.state[id+'cc']);
  }

  componentDidMount()
  {
    
    getHelp().then(response => response.data)
    .then((data) => {
      this.setState({ help: data })
      //console.log(this.state.users)
     })
     
     
  }

  render() {
    return (
      <>
        <div className="row">
          <div className="col-md-12">

              { this.state.help!=null && this.state.help.map((help)=>

              <div className="accordion accordion-toggle-arrow" id="accordionExample1">
                  <div className="card">
                      <div className="card-header">
                          <div className={"card-title "+this.state[help.id+'cc']} data-toggle="collapse" data-target="#collapseOne1" onClick={()=>this.accordion(help.id,help.videoUrl)}>
                              {help.title}
                          </div>
                      </div>
                      <div id="collapseOne1" className={"collapse " + this.state[help.id+'ck']} data-parent="#accordionExample1">
                          <div className="card-body">
                              <ReactPlayer url={this.state[help.id+'url']} controls="true" />
                          </div>
                      </div>
                  </div>
                  
              </div>
              )}
          </div>
         
        </div>

      

       
      </>
    );
  }
}
